import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon, BookOpenIcon, CalendarIcon, BadgeCheck, CheckCircle } from 'lucide-react';
const HeaderGlpAdv2 = () => {
  return <header className="bg-white" style={{
    fontFamily: 'Georgia, Cambria, "Times New Roman", serif'
  }} data-id="element-17532" data-mp="1e5k2jul9e1y8">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-17533" data-mp="15am6wfqq8b37"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-17534" data-mp="qdva8e8ftdha">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-17535" data-mp="qfzn3lobdmtp">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-17536" data-mp="vdrca7xkquu7">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-17537" data-mp="hfjksfjb4lqf">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-17538" data-mp="2brzk0wdoqzls">
          <div className="text-left" data-id="element-17539" data-mp="5mxk0upm16to">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-17540" data-mp="5le2z1w4qrqu">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-17541" data-mp="3ivjy9dgzsqdb">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>

      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-17542" data-mp="3ssojnb30kht2">
        <div className="max-w-4xl mx-auto" data-id="element-17543" data-mp="3nstt58n5hu8j">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-17544" data-mp="3nqz87ubvq24g">
            INVESTIGATIVE REPORT
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-6" data-id="element-17545" data-mp="1334hf4hquok2">
            Investigative Report: What Happens To Your Brain's Reward System On
            GLP-1 Drugs—And Why It's Not In The Prescribing Information
          </h1>

          <div className="my-6" data-id="element-17546" data-mp="1k3pepof6hlim">
            <img src="https://cdn.magicpatterns.com/uploads/gz84jYVasZBwWRkhgymjxp/b2QZCI4Ek7lGaGIZHSfBo.png" alt="Person in distress in car" className="w-full h-auto rounded-sm" data-id="element-17547" data-mp="1k3fl7quxcw86" />
          </div>

          <p className="text-lg font-medium text-gray-700 mb-6 leading-relaxed border-l-4 border-gray-800 pl-4" data-id="element-17548" data-mp="rftbs1z0mxde">
            The Breakthrough Discovery From Uppsala University Research That
            Saved My Sister - And Is Allowing Over 36,700 People To Continue
            Losing Weight With NO Depression, Anxiety, Numbness, Disconnected
            Feeling, Loss Of Motivation, Insomnia, Nightmares or Sense Of Dread
          </p>

          {/* Author Byline */}
          <div className="flex items-center gap-3 mb-6 pb-5 border-b border-gray-200" data-id="element-17549" data-mp="dndelhssptke">
            <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 bg-gray-200" data-id="element-17550" data-mp="dlahyex5126p">
              <img src="https://cdn.magicpatterns.com/uploads/4PvNLd6RsPB1kVDZBzePem/c844778a-6484-4fd0-ade7-865535abf330.png" alt="Journalist" className="w-full h-full object-cover" data-id="element-17551" data-mp="61rotfu6jske" />
            </div>
            <div className="flex-1" data-id="element-17552" data-mp="3sd5azof8bpqx">
              <div className="flex items-center gap-1 mb-1" data-id="element-17553" data-mp="3nd0ye9hfzf5z">
                <span className="text-sm font-medium text-gray-900" data-id="element-17554" data-mp="3janpxdbb935i">
                  Written by Sarah Mitchell
                </span>
                <BadgeCheck className="h-4 w-4 text-blue-600" data-id="element-17555" data-mp="3ejnxak98578t" />
              </div>
              <div className="text-xs text-gray-600 mb-1" data-id="element-17556" data-mp="39kb7prqyxm2j">
                Investigative Health Journalist • 17 Yrs Exp
              </div>
              <div className="flex items-center gap-3 text-xs text-gray-500" data-id="element-17557" data-mp="34nb1ngu4cjbf">
                <div className="flex items-center gap-1" data-id="element-17558" data-mp="2zllnhsblnpj4">
                  <ClockIcon className="h-3 w-3" data-id="element-17559" data-mp="2vl1rwt6octz3" />
                  <span data-id="element-17560" data-mp="2vmctqngk7rnk">14 min read</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-17561" data-mp="3kbz9xshcxdr4">
                  <EyeIcon className="h-3 w-3" data-id="element-17562" data-mp="3kchf5elzz2b6" />
                  <span data-id="element-17563" data-mp="3pbc1urn35b0k">31,542 views</span>
                </div>
              </div>
            </div>
          </div>

          <p className="mb-5 text-base leading-relaxed text-gray-700" data-id="element-17564" data-mp="3bicn4rv4nku2">
            If you're on Semaglutide or Tirzepatide—and you're noticing things
            like:
          </p>

          <div className="space-y-2 mb-6" data-id="element-17565" data-mp="31kygtl2x4cfh">
            <div className="flex items-start gap-2" data-id="element-17566" data-mp="31jwtoi8mnzhe">
              <CheckCircle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-17567" data-mp="36kku1uiqxsoa" />
              <p className="text-gray-700 text-base leading-relaxed" data-id="element-17568" data-mp="2skta7d5jti2d">
                Anxiety that comes from nowhere and won't leave
              </p>
            </div>
            <div className="flex items-start gap-2" data-id="element-17569" data-mp="2wo7r061ba2gv">
              <CheckCircle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-17570" data-mp="qswv5tk69q2u" />
              <p className="text-gray-700 text-base leading-relaxed" data-id="element-17571" data-mp="uva40qu7u43u">
                A flat, numb feeling where emotions used to be
              </p>
            </div>
            <div className="flex items-start gap-2" data-id="element-17572" data-mp="2fag98ucg1k1o">
              <CheckCircle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-17573" data-mp="2bc8shzhzciqh" />
              <p className="text-gray-700 text-base leading-relaxed" data-id="element-17574" data-mp="2p2vsduzh8eo5">
                Vivid nightmares that jolt you awake
              </p>
            </div>
            <div className="flex items-start gap-2" data-id="element-17575" data-mp="2ka2n9603j4bj">
              <CheckCircle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-17576" data-mp="2yzqqicru8d1w" />
              <p className="text-gray-700 text-base leading-relaxed" data-id="element-17577" data-mp="2u28h6l9wrvtd">
                A sense of dread you can't explain
              </p>
            </div>
            <div className="flex items-start gap-2" data-id="element-17578" data-mp="37zdpyt10b8sb">
              <CheckCircle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-17579" data-mp="333gbytd7ueip" />
              <p className="text-gray-700 text-base leading-relaxed" data-id="element-17580" data-mp="1dmxe9cpfz2g2">
                Zero motivation to do things you used to love
              </p>
            </div>
            <div className="flex items-start gap-2" data-id="element-17581" data-mp="18qqg463aev8o">
              <CheckCircle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-17582" data-mp="38rn7nts7ig3w" />
              <p className="text-gray-700 text-base leading-relaxed" data-id="element-17583" data-mp="3dowx39flirrq">
                Feeling disconnected from people close to you
              </p>
            </div>
          </div>

          <p className="mb-5 text-base leading-relaxed text-gray-700" data-id="element-17584" data-mp="3mq4wjutulyne">
            ...you're not imagining it. You're not alone.
          </p>

          <p className="mb-5 text-base leading-relaxed text-gray-700" data-id="element-17585" data-mp="3roy9nm583nn1">
            And it's not permanent—if you understand{' '}
            <strong data-id="element-17586" data-mp="gtszl7mgsbk">
              what's actually happening inside your body right now
            </strong>
            .
          </p>

          <p className="mb-6 text-base leading-relaxed text-gray-700" data-id="element-17587" data-mp="a99bqkqqtkxi">
            In my 17 years as an investigative health journalist, I've covered
            dozens of pharmaceutical controversies. But this one hit close to
            home.
          </p>
        </div>
      </div>
    </header>;
};
export default HeaderGlpAdv2;